import useIsMobile from "@/hooks/useIsMobile";
import { Link } from "react-router-dom";
import styled from "styled-components";

const FamilySite = () => {
  const isMobile = useIsMobile();
  return (
    <Container $ismobile={isMobile}>
      <Link to="https://www.spacemap42.com">Home</Link>
      <Link to="https://platform.spacemap42.com">Platform</Link>
    </Container>
  );
};

export default FamilySite;

const Container = styled.section<{ $ismobile: boolean }>`
  width: auto;
  position: ${props => (props.$ismobile ? "relative" : "absolute")};
  right: ${props => (props.$ismobile ? "0" : "3rem")};
  gap: 2rem;

  display: flex;

  > a {
    all: unset;

    color: #e7c11d;
    cursor: pointer;
    font-size: 1.3rem;
    font-weight: 600;
  }
  @media screen and (max-width: 370px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;
